//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 按需引入部分组件
import { RQ } from 'utils';
import * as F from 'utils/F';
import { dateFormat } from 'utils/filters';
import { yoButton, NavBar } from 'components';
import action from './action';
import {
  Tag,
  Row,
  Col,
  Cell,
  CellGroup,
  Swipe,
  SwipeItem,
  GoodsAction,
  GoodsActionBigBtn,
  GoodsActionMiniBtn,
  Tab,
  Tabs,
  Rate,
  Popup,
  Actionsheet,
  RadioGroup,
  Radio,
  Button,
  Checkbox,
  CheckboxGroup
} from 'vant';

export default {
  name: 'coupon',
  props: ['params', 'orderCode', 'orderPrice'],
  metaInfo: {
    title: '订单支付'
  },
  created: async function () {
    await this.getOrderPayPrice();
  },
  updated() {
    console.log('data ---> ', this.data);
  },
  data() {
    return {
      data: {}
    };
  },
  computed: {},
  filters: {
    dateFormat
  },
  components: {
    yoButton,
    NavBar,
    Tag,
    Row,
    'van-col': Col,
    Cell,
    CellGroup,
    Swipe,
    SwipeItem,
    GoodsAction,
    GoodsActionBigBtn,
    GoodsActionMiniBtn,
    Tab,
    Tabs,
    Rate,
    'van-popup': Popup,
    Actionsheet,
    RadioGroup,
    Radio,
    'van-button': Button,
    'van-checkbox': Checkbox,
    'van-checkbox-group': CheckboxGroup
  },
  methods: {
    ...action
  }
};



// WEBPACK FOOTER //
// ./src/module/cart/pay/page.vue